import { useState } from "react";
import { ChevronDown, ChevronUp, MailCheck } from "lucide-react";

const FROM = process.env.REACT_APP_OUTREACH_EMAIL;

const GUIDES = {
  gmail: {
    label: "Gmail",
    steps: [
      "Apri Gmail dal computer → icona ingranaggio → \"Visualizza tutte le impostazioni\" → scheda \"Account e importazione\".",
      `In "Invia messaggi come" clicca "Aggiungi un altro indirizzo email": nome "Aurora-ADV", email ${FROM}. Lascia spuntato "Considera come alias".`,
      "Inserisci il server SMTP del tuo provider del dominio, la porta (465 con SSL oppure 587 con TLS), il nome utente (l'indirizzo completo) e la password della casella.",
      "Gmail invia un codice a quella casella: aprilo dalla webmail del provider e confermalo.",
      `Facoltativo: in "Controlla la posta da altri account" aggiungi ${FROM} con i dati POP3 per leggere le risposte in Gmail.`,
      `Quando scrivi, nel campo "Da" scegli ${FROM}. Puoi impostarlo come predefinito.`,
    ],
  },
  outlook: {
    label: "Outlook",
    steps: [
      "Outlook desktop: File → \"Aggiungi account\". Nel nuovo Outlook: Impostazioni → Account → \"Aggiungi account\".",
      `Scrivi ${FROM} → \"Opzioni avanzate\" → \"Configura manualmente\" → scegli IMAP.`,
      "Posta in arrivo: server IMAP del provider, porta 993, SSL/TLS. Posta in uscita: server SMTP, porta 465 (SSL) o 587 (STARTTLS).",
      "Utente: l'indirizzo completo. Password: quella della casella. Conferma con \"Connetti\".",
      `Quando scrivi, nel campo "Da" scegli ${FROM}.`,
    ],
  },
  apple: {
    label: "Apple Mail",
    steps: [
      "Mac: Mail → Impostazioni → Account → \"+\" → \"Altro account Mail\". iPhone: Impostazioni → Mail → Account → Aggiungi account → Altro.",
      `Nome "Aurora-ADV", email ${FROM} e password della casella → Accedi.`,
      "Se Mail non trova i server da solo, scegli IMAP e inserisci il server in arrivo (porta 993) e quello in uscita SMTP (porta 465 o 587) del provider.",
      "Su iPhone imposta l'account come predefinito in Impostazioni → Mail → \"Account di default\": così il pulsante \"App di posta\" usa questa casella.",
    ],
  },
};

export const MailboxGuide = () => {
  const [open, setOpen] = useState(false);
  const [tab, setTab] = useState("gmail");
  return (
    <div data-testid="mailbox-guide" className="border border-[#d5dbde] bg-white">
      <button data-testid="mailbox-guide-toggle" onClick={() => setOpen(!open)} className="w-full flex items-center gap-3 px-5 py-4 text-left">
        <MailCheck className="w-4 h-4 text-[#E0262C]" />
        <span className="mr-auto text-sm text-[#2B3036]">Collega la casella {FROM} a Gmail, Outlook o Apple Mail</span>
        {open ? <ChevronUp className="w-4 h-4 text-[#6b7280]" /> : <ChevronDown className="w-4 h-4 text-[#6b7280]" />}
      </button>
      {open && (
        <div className="border-t border-[#d5dbde] px-5 py-4 space-y-4">
          <div className="flex gap-2">
            {Object.entries(GUIDES).map(([id, g]) => (
              <button key={id} data-testid={`mailbox-guide-tab-${id}`} onClick={() => setTab(id)}
                className={`text-xs px-3 h-8 border ${tab === id ? "border-[#E0262C] text-[#2B3036] bg-[#fdecec]" : "border-[#d5dbde] text-[#5b6168] hover:text-[#E0262C]"}`}>{g.label}</button>
            ))}
          </div>
          <ol data-testid={`mailbox-guide-steps-${tab}`} className="list-decimal pl-5 space-y-2 text-sm text-[#3f454c] max-w-3xl">
            {GUIDES[tab].steps.map((s) => <li key={s}>{s}</li>)}
          </ol>
          <p className="text-[11px] text-[#6b7280] max-w-3xl">
            I dati dei server (SMTP, IMAP e POP3) li trovi nel pannello del provider da cui hai comprato il dominio, di solito nella sezione Email. Inseriscili solo nel tuo programma di posta: la piattaforma non li salva.
          </p>
        </div>
      )}
    </div>
  );
};
